import { render } from "./Sales.vue?vue&type=template&id=462a5d62&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=462a5d62&scoped=true&lang=css"
import "./Sales.vue?vue&type=style&index=1&id=462a5d62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462a5d62"]])

export default __exports__